import React from "react";
import { Project } from "./ProjectPerformance";
import { useColorMode } from "@chakra-ui/react";
import { getThemeClasses } from "../../../utils/themeUtils";

interface ProjectListProps {
  projects: Project[];
  color: string;
  bg: string;
  onSelectProject: (project: Project) => void;
}

const ProjectList: React.FC<ProjectListProps> = ({
  projects,
  onSelectProject,
}) => {
  const { colorMode } = useColorMode();
  const isDark = colorMode === "dark";
  const theme = getThemeClasses(isDark);

  return (
    <div className={`overflow-hidden rounded-md border ${theme.border} ${theme.card}`}>
      <div className="flex-1 overflow-y-auto overflow-x-auto" style={{ maxHeight: "66vh" }}>
        <table className="min-w-full text-sm">
          <thead className={`${isDark ? 'bg-[#14161B]' : 'bg-gray-50'} sticky top-0`}>
            <tr>
              <th className={`py-2 px-4 text-left w-1/2 font-semibold ${isDark ? 'text-white' : 'text-gray-700'}`}>Project Name</th>
              <th className={`py-2 px-4 text-center font-semibold ${isDark ? 'text-white' : 'text-gray-700'}`}>Channels</th>
              <th className={`py-2 px-4 text-center w-32 font-semibold ${isDark ? 'text-white' : 'text-gray-700'}`}>Actions</th>
            </tr>
          </thead>
          <tbody className={`${isDark ? 'divide-y divide-[#2E2F33]' : 'divide-y divide-gray-200'}`}>
            {projects.map((project) => (
              <tr
                key={project.id}
                className={`${isDark ? 'hover:bg-[#2A3441]' : 'hover:bg-[#F2F4F7]'} transition-all`}
              >
                <td className="py-2 px-4">
                  <div className="flex items-center space-x-2">
                    <span className={`w-7 h-7 rounded-lg border-2 ${isDark ? 'border-[#B59143] bg-transparent' : 'border-[#E8C16C] bg-white'} flex items-center justify-center flex-shrink-0`}>
                      <span className={`${isDark ? 'text-[#FBD282]' : 'text-[#B59143]'} font-bold text-sm`}>
                        {project.name.charAt(0).toUpperCase()}
                      </span>
                    </span>
                    <span
                      className={`${isDark ? 'text-white' : 'text-gray-700'} text-sm truncate max-w-xs`}
                      title={project.name}
                    >
                      {project.name}
                    </span>
                  </div>
                </td>
                <td className="py-2 px-4 text-center">
                  <span className={`text-xs rounded-full px-3 py-1 font-medium ${isDark ? 'border border-[#B59143] text-[#FBD282]' : 'bg-[transparent] text-[#B59143] border border-[#E8C16C]'}`}>
                    {project.channels.length} Channels
                  </span>
                </td>
                <td className="py-2 px-4 text-center">
                  <button
                    className={`text-xs px-3 py-1 rounded transition border ${isDark ? 'border-[#B59143] text-white hover:bg-[#2A3441]' : 'border-[#B59143] text-[#B59143] hover:bg-[#FFF7E6]'} focus:outline-none focus:ring-2 focus:ring-[#B59143] focus:ring-opacity-50`}
                    onClick={() => onSelectProject(project)}
                  >
                    View Details
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default ProjectList;